/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ChevronPreviousIcon = /*#__PURE__*/ createSvgIcon(
  'ChevronPreviousIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.125 10l3.417 3.417a.73.73 0 010 1.062.73.73 0 01-1.07-.007l-3.951-3.951a.755.755 0 01-.208-.525c0-.1.017-.194.052-.281a.691.691 0 01.156-.236l3.951-3.951a.73.73 0 011.07-.007.73.73 0 010 1.062L9.125 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ChevronPreviousIcon;
